export type OnboardingValidationInput = {
  distance: string;
  goalTime: string;
  raceDate: Date | null;
  trainingDays: string[];
  longRunDay: string;
  selectedPlanLoaded: boolean;
  recommendedDays: number;
};

export type OnboardingValidationResult = {
  valid: boolean;
  reasons: string[];
};

export function validateOnboarding(
  input: OnboardingValidationInput,
): OnboardingValidationResult {
  const reasons: string[] = [];

  if (!input.distance) reasons.push("distance");
  if (!input.goalTime) reasons.push("goalTime");
  if (!input.raceDate) reasons.push("raceDate");
  if (!input.selectedPlanLoaded) reasons.push("selectedPlan");

  if (!input.trainingDays || input.trainingDays.length === 0) {
    reasons.push("trainingDays");
  }

  // longRunDay is optional. If provided, it must be one of the selected training days.
  if (input.longRunDay && !input.trainingDays.includes(input.longRunDay)) {
    reasons.push("longRunDayNotInTrainingDays");
  }

  // Only enforce recommendedDays once computed (non-zero)
  if (
    input.recommendedDays > 0 &&
    input.trainingDays.length < input.recommendedDays
  ) {
    reasons.push("notEnoughTrainingDays");
  }

  return { valid: reasons.length === 0, reasons };
}
